import type { JSX } from 'preact';
import { t } from '../i18n.js';
import { Markdown } from '../markdown.js';
import { releases, VERSION } from '../changelog.js';

/**
 * **Les nouveautés — le journal que l'on écrit, affiché tel quel.**
 *
 * La décision est de l'utilisateur, et elle tient en une phrase : *une seule
 * version à maintenir*. `synkara/CHANGELOG.md` est donc **le** texte — celui que
 * l'on écrit, celui qu'une lettre d'information reprend, celui que cet écran
 * montre. Rien n'est recopié ici, et il n'y a aucune version courte : deux textes
 * qui disent la même chose finissent par ne plus la dire pareil.
 *
 * Le journal est écrit **pour ceux qui s'en servent** : ce que ça change en une
 * phrase, puis « pour les curieux » en français courant. C'est ce qui rend son
 * affichage direct possible — un journal écrit pour nous aurait demandé une
 * traduction, donc un second texte.
 *
 * **Il n'y a pas de pastille de nouveauté** *(2026-09-20)*. Elle demanderait de
 * retenir ce que chacun a déjà lu — donc un réglage qui voyage entre appareils,
 * donc une décision. Le numéro de version est affiché dans le menu du compte ;
 * qui veut savoir y va.
 */
export function NewsView(): JSX.Element {
  return (
    <div class="stack" data-testid="news">
      {/* **Pas de titre ici** : la barre de l'application porte déjà « Nouveautés ».
          L'écrire deux fois donnait deux titres de même taille l'un sous l'autre,
          et volait au premier vrai titre — celui d'une version — la place qui dit
          qu'il en est un. */}
      <section class="card">
        <p class="card-meta">{t('news.lead', { version: VERSION })}</p>
      </section>

      {releases.map((r) => (
        <section class="card release" key={r.version} data-testid={`release-${r.version}`}>
          <h3 class="release-title">
            <span class="release-version">{r.version}</span>
            {/* La date est celle du fichier, en toutes lettres : la reformater ici
                demanderait de la reparser, et une date en toutes lettres est déjà
                ce qu'on veut lire. */}
            <span class="release-date">{r.date}</span>
          </h3>
          <Markdown source={r.body} />
        </section>
      ))}
    </div>
  );
}
